import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-project-dialog',
  templateUrl: './manual-project-dialog.component.html',
  styleUrls: ['./manual-project-dialog.component.css'],
  standalone: false,
})
export class ManualProjectDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly appnameDialogLink: string = AppConst.ROUTING_LINK_MANUAL_APPNAME_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
